<template>
	<div class="container">
		<h1 class="download">手机客户端下载</h1>
		<p>
			请点击下方下载纽进入页面扫码进行下载 ,进入页面后 iOS 11 以上的朋友可<br />
			直接使用相机应用扫描 , 安装打开即可使用, 感受流畅的移动投注体验
		</p>
		<div class="btns">
			<img
				src="@/static/img/home/download/andBtn.webp"
				alt="icon"
				width="210"
				class="download-icon"
				@click="clickDownload"
			/>
			<img
				src="@/static/img/home/download/iosBtn.webp"
				alt="icon"
				width="210"
				class="download-icon"
				@click="clickDownload"
			/>
		</div>
		<ul class="download-list">
			<li>
				<img src="@/static/img/home/download/banner.webp" alt="banner" width="638" />
			</li>
			<li>
				<p class="info">
					<span>推荐使用以下浏览器：</span>
					<img src="@/static/img/home/download/browser.webp" alt="browser" width="140" class="inline" />
					<span>官方推荐最佳分辨率：</span> 1440px*900px / 1680px*900px / 1920px*1280px
				</p>
			</li>
		</ul>
	</div>
	<!-- 手机客户端下载 -->
</template>
<script>
import { SysKey } from "../../util/sysconfig";

export default {
	data() {
		return {
			H5Link: window.location.origin,
			iosQRURL: SysKey("ImgServerUrl").SysValue + SysKey("IosQrCodeUrl").SysValue,
		};
	},
	methods: {
		clickDownload() {
			window.open(window.systemData.AndroidDownUrl.SysValue, "_blank");
		},
	},
};
</script>
<style lang="less" scoped>
.container {
	width: 100%;
	text-align: center;
	background-image: url("~@/static/img/bg.webp");
	background-repeat: no-repeat;
	background-size: cover;
	padding: 50px 0 70px;
	h1 {
		display: inline-block;
		font-size: 40px;
		text-align: center;
		color: transparent;
		background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);
		-webkit-background-clip: text;
		background-clip: text;
		position: relative;
		margin-bottom: 20px;
		&::before,
		&::after {
			content: "";
			position: absolute;
			top: 50%;
			transform: translateX(-50%);
			background-size: contain;
			width: 213px;
			height: 18px;
		}
		&::before {
			left: -80%;
			background-image: url("~@/static/img/home/title-line-left.webp");
		}
		&::after {
			left: 180%;
			background-image: url("~@/static/img/home/title-line-right.webp");
		}
	}
	p {
		text-align: center;
		margin: 0 auto;
		font-size: 12px;
		color: #888888;
		font-family: "PingFangSC-Light";
	}
	h1.download {
		&::before {
			left: -50%;
		}
		&::after {
			left: 150%;
		}
	}

	.btns {
		margin-top: 8px;
		img {
			cursor: pointer;
		}
		img:first-child {
			margin-right: 10px;
		}
	}
	ul.download-list {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		text-align: left;
		margin-top: -16px;
		li:nth-child(2) {
			text-align: center;
			margin-right: 58px;
			p {
				margin-top: 24px;
				color: #555;
				font-family: "PingFangSC-Regular";
			}
		}
	}

	.inline {
		display: inline-block;
		vertical-align: bottom;
		margin-right: 8px;
	}

	p.info {
		span {
			font-weight: 800;
		}
		&::before,
		&::after {
			content: "";
			width: 120px;
			height: 1px;
			background-color: #309ae5;
			display: inline-block;
			vertical-align: middle;
			margin-right: 8px;
			margin-left: 8px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Client/ClientDownload.vue